<div class="tab-content">

  <!-- Board Selection Bar -->
  <div class="top-bar">
    <mat-form-field appearance="fill" class="board-selector">
      <mat-label>Select Board</mat-label>
      <input
        type="text"
        matInput
        [formControl]="boardControl"
        [matAutocomplete]="auto"
        placeholder="Choose a board"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBoardSelected($event)">
        <mat-option *ngFor="let board of filteredBoards | async" [value]="board.userBoardName">
          <div class="board-option">
            <span class="board-name">{{ board.userBoardName }}</span>
            <mat-chip class="board-type-chip">{{ getBoardTypeLabel(board.boardType) }}</mat-chip>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <!-- Board Viewers -->
  <div class="board-viewer-container" *ngIf="selectedBoard; else noBoardSelected">
    
    <!-- Tile Board Viewer -->
    <bhub-tile-board-viewer
      *ngIf="selectedBoard.boardType === boardTypes.TileBoard"
      [board]="selectedBoard"
      [filterBar]="filterBar"
      style="height: 100%; flex: 1;">
    </bhub-tile-board-viewer>

    <!-- Spreadsheet Board Viewer -->
    <bhub-spreadsheet-board-viewer
      *ngIf="selectedBoard.boardType === boardTypes.SpreadsheetBoard"
      [board]="selectedBoard"
      [filterBar]="filterBar"
      style="height: 100%; flex: 1;">
    </bhub-spreadsheet-board-viewer>

  </div>

  <!-- No Board Selected State -->
  <ng-template #noBoardSelected>
    <div class="no-board-selected">
      <div class="no-board-content">
        <mat-icon class="large-icon">dashboard</mat-icon>
        <h3>Select a Board to View</h3>
        <p>Choose a board from the dropdown above to start viewing your data</p>
        
        <div class="board-count" *ngIf="boards.length > 0">
          <mat-chip>{{ boards.length }} board(s) available</mat-chip>
        </div>
      </div>
    </div>
  </ng-template>

</div>